import { apiSelector } from '@ackee/redux-utils';
import type { ApiReducerState } from '@ackee/redux-utils/lib/config';
import { ApiReducerKey, EntityKey } from '../../../../../constants';

export const selectIotConfigApi = (state): ApiReducerState =>
    apiSelector(state, EntityKey.IOT_CONFIG, ApiReducerKey.LIST);
    

export const selectIotConfig = (state): any[] => 
    state.entities[EntityKey.IOT_CONFIG][ApiReducerKey.LIST];